import React, { useMemo } from "react";
import { GroupProps, NoticeProps } from "react-select";
import {
    CustomLoadingMessage,
    CustomNoOptionsMessage,
    Group
} from "@components/UI/Inputs/SelectInput/SelectInputCustoms";
import { Generation } from "@app/store/types";
import { ColorInputAccent } from "@app/styles/color-palette";
import { generateGenerationLabel } from "@shared/lib/utils/generateGenerationLabel";
import { CustomSelectComponents, SelectValue } from "../types";
import classes from "../MainFilter.module.scss";

export const useMainFilterHelpers = () => {
    const customSelectComponents: CustomSelectComponents = useMemo(() => {
        const GroupComponent = (props: GroupProps<unknown>) =>
            React.createElement(Group, { ...props, className: classes.groupSelect });
        const NoOptionsComponent = (props: NoticeProps<unknown>) =>
            React.createElement(CustomNoOptionsMessage, {
                ...props,
                className: classes.customSelect
            });
        const LoadingComponent = () =>
            React.createElement(CustomLoadingMessage, { className: classes.customSelect });

        return {
            Group: GroupComponent,
            NoOptionsMessage: NoOptionsComponent,
            LoadingMessage: LoadingComponent
        };
    }, []);

    const createSelectValue = (
        value: string | number | undefined,
        label: string = "",
        alias?: string
    ): SelectValue | undefined => {
        if (value === undefined || value === null || value === "") return undefined;
        return { value, label: label || value.toString(), alias };
    };

    const createGenerationSelectValue = (
        generation?: Generation | null
    ): SelectValue | undefined => {
        if (!generation || !generation.id) return undefined;
        const fullLabel = generateGenerationLabel(generation);
        return { value: generation.id, label: fullLabel };
    };

    const selectInputFonts = useMemo(
        () => ({
            fontWeight: 500,
            fontSize: "13px"
        }),
        []
    );

    const topSelectsFontStyle = useMemo(
        () => ({
            fontWeight: 600,
            fontSize: 16,
            color: ColorInputAccent
        }),
        []
    );

    return {
        customSelectComponents,
        createSelectValue,
        createGenerationSelectValue,
        selectInputFonts,
        topSelectsFontStyle
    };
};